import OperatorError from './OperatorError';

export default OperatorError;
